import React, { useEffect } from 'react';
import GlobalStyle from '../../src/styles/globalStylesV2';
import NewHeader from '../../src/components/HomePage/NewHeader';
import { HomeWrapper } from '../../src/components/HomePage/HomeBanner/styled';
import TopicListingPage from '../../src/components/TopicListing/TopicListingPage';
import NewFooter from '../../src/components/HomePage/NewFooter';
import { getTopicList } from '../../src/datafetchers/HomePage';
import { getFilteredCategoryContent } from '../../src/Utils/helper';
import { storeDataFetcher } from '../../src/datafetchers/Store';
import { NextSeo } from 'next-seo';
import { fireViewedScreenEvent } from '../../src/Utils/useFirebase';

export async function getStaticProps() {
  const topicListData = await getTopicList();
  const data = await storeDataFetcher({
    skip: 0,
    limit: 10,
    lang: 'en',
    inApp: false,
    desktopView: true,
    key: 'store',
  });
  return {
    props: {
      topicListData,
      categoryData: getFilteredCategoryContent(data?.data?.categories),
    },
    revalidate: 60,
  };
}

export default function TopicListing(props) {
  const { topicListData, categoryData } = props;
  useEffect(() => {
    fireViewedScreenEvent();
  }, []);
  const metaTitle =
    'Discover Our Extensive Range of Topics & Articles | MyloFamily';
  const metaDescription =
    'Discover our extensive range of topics from reproductive health to pregnancy complications and articles and videos on them.';
  return (
    <>
      <GlobalStyle />
      <NextSeo title={metaTitle} description={metaDescription} />
      <NewHeader nostrip={true} categoryData={categoryData} />
      <HomeWrapper noPadding>
        <TopicListingPage
          recommendations={topicListData?.recommendations}
          tagsDetails={topicListData?.tagsDetails}
          breadCrumbs={topicListData?.Breadcrumbs}
        />
      </HomeWrapper>
      <NewFooter />
    </>
  );
}
